import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, signInAnonymously } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBICWHThlHmrXNNqsGYLy78QP3A9uXDhAc",
    authDomain: "swiftclean-4a952.firebaseapp.com",
    databaseURL: "https://swiftclean-4a952-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "swiftclean-4a952",
    storageBucket: "swiftclean-4a952.appspot.com",
    messagingSenderId: "1064207979878",
    appId: "1:1064207979878:web:4a685201a67af91db224a7",
    measurementId: "G-HFQKDHRRQJ"
};
const app = initializeApp(firebaseConfig);


export const db = getFirestore(app)
export const storage = getStorage(app);
export const auth = getAuth(app);

// Initialize anonymous authentication
export const initializeAuth = async () => {
    try {
        await signInAnonymously(auth);
    } catch (error) {
        console.error('Error initializing anonymous auth:', error);
    }
}; 